import { Component } from '@poa/core';
import { action, observable, Observer } from '@poa/state';
import React from 'react';
import DataTable from '../components/data-table/data-table';
import Navbar from '../components/navbar';
import { ProfileModal } from '../components/profile-modal/profile-modal';
import RouteLoading from '../components/route-loading';
import TableFilter, { PageModeReports } from '../components/table-filter';
import { ACCESS_LEVEL } from '../store/auth/auth.constants';

class ReportsArchiveDetailPage extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa

  localState = observable({
    isModalOpened: false,
    selectedProfileId: null,
    pageMode: PageModeReports.reports
  });

  onModalClose = action(() => {
    this.localState.isModalOpened = false;
    this.localState.selectedProfileId = null;
  });

  onModalOpen = action(profileId => {
    this.localState.selectedProfileId = profileId;
    this.localState.isModalOpened = true;
  });

  saveColumnPreset = async preset => {
    await this.actions.reportArchivesActions.saveColumnPreset(preset);
  };

  render() {
    const { filters, selectors, ui } = this.store.reportArchives;
    const {
      changeGrouping,
      changeStatus,
      changeColumnPreset,
      changeColumnVisibility,
      changeRounding,
      changeSearch,
      changePresetOrder,
      deletePreset,
      toggleFavorite,
      toggleAllColumns
    } = this.actions.reportArchivesActions;

    const isDecimalThunk = () => filters.isDecimal;

    return (
      <RouteLoading
        key="2"
        meta={this.store.reportArchives.meta}
        render={() => (
          <div className="content">
            <Navbar />

            <div className='under-navbar-content'>
              <TableFilter
                state={filters}
                selectors={selectors}
                withoutDatesChange
                onGroupingChange={changeGrouping}
                onStatusChange={changeStatus}
                onColumnPresetChange={changeColumnPreset}
                onColumnChange={changeColumnVisibility}
                onColumnPresetSubmit={this.saveColumnPreset}
                deletePreset={deletePreset}
                onIsFractionalChange={changeRounding}
                onSearchChange={changeSearch}
                withoutFilteringChange
                withoutGroupingChange={this.store.auth.accessLevel === ACCESS_LEVEL.operator}
                changePresetOrder={changePresetOrder}
                onAllColumnsToggle={toggleAllColumns}
                getTableNode={() => this.node}
                datesDisabled={true}
              />
              <div className="container">
                <div className="inner">
                  <div className="inner-scroll reports-table">
                    <Observer>
                      {() =>
                        selectors.filteredData.map((table, idx) => (
                          <DataTable
                            tableFiltersKey="reports-archives-filters"
                            ref={node => (this.node = node)}
                            key={idx}
                            data={table}
                            columnSettings={filters.columnSettings}
                            favorites={ui.favorites}
                            toggleFavorite={toggleFavorite}
                            isDecimalThunk={isDecimalThunk}
                            requestModalOpen={this.onModalOpen}
                            selectors={selectors}
                            initialSortingMap={{ total: 'desc' }}
                            account_filters={null}
                          />
                        ))
                      }
                    </Observer>
                    <Observer>
                      {() => (
                        <ProfileModal
                          isOpened={this.localState.isModalOpened}
                          requestClose={this.onModalClose}
                          profileId={this.localState.selectedProfileId}
                        />
                      )}
                    </Observer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

export default Component({ namespaces: ['common'] })(ReportsArchiveDetailPage);
